import React from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Icon } from '@perxis-auto/ui-kit/lib/components/Icon';
import { Result } from '@perxis-auto/ui-kit/lib/components/Result';

import { Link } from '@/components/Link';
import PAGES from '@/constants/pages';

import { ErrorMessageProps } from './ErrorMessage.types';

import styles from './ErrorMessage.module.scss';

function ErrorMessage({ translationKey, iconName }: ErrorMessageProps) {
  const { t } = useTranslation();

  const { resetBoundary } = useErrorBoundary();

  return (
    <div className={styles.errorMessage}>
      <Result
        icon={!!iconName && <Icon name={iconName} size={40} />}
        title={t(`${translationKey}.title`)}
        subTitle={t(`${translationKey}.subTitle`)}
        extra={
          <Link type="ghost" htmlType="button" onClick={resetBoundary} to={PAGES.Cars}>
            {t(`${translationKey}.redirect`)}
          </Link>
        }
      />
    </div>
  );
}

export default ErrorMessage;
